import { Stack, Typography } from "@mui/material";
import React from "react";
import Lottie from "react-lottie";
import * as CheckmarkAnimationSource from "../../../../lottieAnimations/checkmark.json";
import { ANSpriteLogo } from "@answersnow/pkg-theme";

// Create a deep copy of the animation data
const CheckmarkAnimation = JSON.parse(JSON.stringify(CheckmarkAnimationSource));

export default function ApprovingFlowBlock({ isLoading, isSuccessful, isTentative, ...props }) {
  return (
    <Stack height="320px" justifyContent="center" alignItems="center" {...props}>
      {isLoading && <ANSpriteLogo />}
      {isSuccessful && (
        <>
          <Typography variant="h5" color="primary.main">
            {isTentative ? "Schedule Set As Tentative!" : "Schedule Approved!"}
          </Typography>
          <Lottie
            height="74px"
            width="76px"
            options={{
              loop: false,
              autoplay: true,
              animationData: CheckmarkAnimation,
              rendererSettings: {
                preserveAspectRatio: "xMidYMid slice",
              },
            }}
          />
        </>
      )}
    </Stack>
  );
}
